import { Component, computed, input } from '@angular/core';

import { RouterLink, RouterLinkActive } from '@angular/router';
import { NavLink } from '@welma-education/common';
import { TranslatePipe } from '@ngx-translate/core';

export type VerticalNavListColor = 'primary';
const defaultColor: VerticalNavListColor = 'primary';

const colors: Record<VerticalNavListColor, Record<'active' | 'inactive', string>> = {
  primary: {
    active: 'border-primary-600 bg-primary-100 text-primary-700',
    inactive: 'border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900',
  },
};

@Component({
  selector: 'wma-tabs-with-underline-vertical',
  templateUrl: 'tabs-with-underline-vertical.html',
  host: {
    class: 'block',
  },
  imports: [RouterLinkActive, RouterLink, TranslatePipe],
})
export class TabsWithUnderlineVertical {
  links = input<NavLink[]>([]);
  color = input<VerticalNavListColor>();

  klass = computed(() => {
    return colors[this.color() || defaultColor];
  });
}
